<template>
  <div class="flex-1 flex flex-col overflow-hidden">
    <Header :title="showLang[selectLang]['views']['Home']['page_name']" @childLang="useLang"/>
    <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200">
      <div class="container w-4/5 mx-auto bg-white rounded-xl" :style="borderStyle == 0 ? { 'border-right': '5px solid #3566A5', 'border-left': '5px solid #3566A5' } : { 'border-right': '5px solid #200318', 'border-left': '5px solid #200318' }" >
        <div class="container">
          <div class="flex rounded-xl overflow-hidden text-white">
            <div class="w-full text-left sm:rounded-xl sm:overflow-hidden mx-1 h-full max-h-1/4">
              <LinkAccount v-bind:lang="showLang[selectLang]" v-bind:tiktokLang="showTiktokLangg[selectLang]" v-bind:firstLoginStatue="firstLoginStatue" v-bind:transmitFbNum="transmitFbNum" v-bind:transmitTiktokNum="transmitTiktokNum" v-bind:user_info="user_info" :guideStep="nowStep" @nextStep="nextStep" @closeTips="closeTips" @childOpenFirstLogin="openFirstLogin" @childChangeLinkType="setChangeLinkType" @adaccountLength="updateAdaccount" @pageLength="updatePage" @childActive="childActive"/>
              }
            </div>
          </div>
        </div>
        <hr v-if="borderStyle == 0 && (memberId != null && memberId != '')" class="mx-10 mb-10" style="border-top:3px solid #3566A5;">
        <hr v-if="borderStyle == 1 && (tiktokMemberId != null && tiktokMemberId != '')" class="mx-10 mb-10" style="border-top:3px solid #200318;">
        <div class="container">
          <Plan v-if="borderStyle == 0 && (memberId != null && memberId != '')" v-bind:plan="plans" v-bind:payList="payList" v-bind:userStatus="userStatus" v-bind:isExpired="is_expired" v-bind:connectionCard="connectionCard" v-bind:memberId="memberId" v-bind:usePlanId="usePlanId" v-bind:lang="showLang[selectLang]" v-bind:showPlans="showPlans" v-bind:transmitFbNum="transmitFbNum" v-bind:transmitTiktokNum="transmitTiktokNum" v-bind:source="source" v-bind:borderStyle="borderStyle" v-bind:useFbCustomize="useFbCustomize" :guideStep="nowStep" @canUseFbCustomize="canUseFbCustomize"/>
          <TikTokPlan v-if="borderStyle == 1 && (tiktokMemberId != null && tiktokMemberId != '')" v-bind:plan="tiktokPlans" v-bind:payList="payList" v-bind:userStatus="tiktokUserStatus" v-bind:isExpired="tiktokIsExpired" v-bind:connectionCard="tiktokConnectionCard" v-bind:memberId="tiktokMemberId" v-bind:usePlanId="tiktokUsePlanId" v-bind:lang="showLang[selectLang]" v-bind:showPlans="showPlans" v-bind:transmitFbNum="transmitFbNum" v-bind:transmitTiktokNum="transmitTiktokNum" v-bind:source="tiktokSource" v-bind:borderStyle="borderStyle" :guideStep="nowStep" />
        </div>
        <hr v-if="borderStyle == 0 && (memberId != null && memberId != '')" class="m-10" style="border-top:3px solid #3566A5;">
        <hr v-if="borderStyle == 1 && (tiktokMemberId != null && tiktokMemberId != '')" class="m-10" style="border-top:3px solid #200318;">
        <div class="container">
          <div class="flex rounded-xl overflow-hidden text-white">
            <div class="w-full lg:text-center md:text-left sm:text-left sm:rounded-xl sm:overflow-hidden">
              <div class="px-11 py-5 bg-white space-y-6" style="position:relative">
                <loading :active="!this.showMemberInfo"
                        :can-cancel="true"
                        :on-cancel="onCancel"
                        :is-full-page="false"
                        :color="'#fff'"
                        :background-color="'#000'"
                        :opacity="'0.8'"
                        :loader=" dots">
                </loading>
                <div v-if="borderStyle == 0 && (memberId != null && memberId != '')" class="flex flex-col">
                  <div class="text-gray-700 text-left">
                    {{showLang[selectLang]['views']['Home']['personal_information_text']}}
                    <span v-if="isPay_emptyInvoice" class="ml-5 text-gray-500 text-sm">{{showLang[selectLang]['views']['Home']['payment_information_text']}}</span>
                  </div>
                  <div class="lg:flex md:block sm:block justify-evenly my-8">
                    <div class="relative shadow h-28 w-28 border-white rounded-full overflow-hidden">
                      <img class="object-cover w-full h-full"
                        :src="img">
                    </div>
                    <div class="flex-auto sm:ml-5 justify-evenly">
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['member_id_text']}}</span>
                        <span class="text-gray-500">{{ account }}</span>
                      </div>
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['member_name_text']}}</span>
                        <span class="text-gray-500">{{ member_name }}</span>
                      </div>
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['member_email_text']}}</span>
                        <span class="text-gray-500">
                          <span v-if="!isEditEmail">{{ email }}</span>
                          <input
                            v-if="isEditEmail"
                            v-model="tmp_email"
                            class="p-inputtext p-component py-0 w-60 h-4 underline-box border-show bg-transparent"
                            type="text"
                          />
                          <button
                            v-if="isEditEmail"
                            class="hover:bg-gray-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-gray-400 text-xs transition duration-500 ease-in-out border-2"
                            @click="isEditEmail=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                          <button
                            v-if="isEditEmail"
                            class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-blue-800 text-xs transition duration-500 ease-in-out border-2 border-yellow-400"
                            @click="emailUpdate()"
                            >{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                          <i
                            v-if="!isEditEmail"
                            class="pi pi-pencil cursor-pointer pl-2"
                            style="fontSize: 0.8rem"
                            @click="viewEdit('email')"
                            v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                        </span>
                      </div>
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['member_phone_text']}}</span>
                        <span class="text-gray-500">
                          <span v-if="!isEdit">{{ phone }}</span>
                          <input
                            v-if="isEdit"
                            v-model="tmp_phone"
                            class="p-inputtext p-component py-0 w-28 h-4 underline-box border-show bg-transparent"
                            type="text"
                          />
                          <button
                            v-if="isEdit"
                            class="hover:bg-gray-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-gray-400 text-xs transition duration-500 ease-in-out border-2"
                            @click="isEdit=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                          <button
                            v-if="isEdit"
                            class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-blue-800 text-xs transition duration-500 ease-in-out border-2 border-yellow-400"
                            @click="phoneUpdate()"
                            >{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                          <i
                            v-if="!isEdit"
                            class="pi pi-pencil cursor-pointer pl-2"
                            style="fontSize: 0.8rem"
                            @click="viewEdit('phone')"
                            v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                        </span>
                      </div>
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['payment_info_text']}}</span>
                        <a href="javascript:void(0);" class="text-blue-500 underline" @click="display=true">{{showLang[selectLang]['views']['Home']['payment_info_click_text']}}</a>
                      </div>
                      <PaymentInfoDialog v-bind:lang="showLang[selectLang]" v-bind:invoices="invoices" v-bind:borderStyle="borderStyle" v-bind:memberId="memberId" v-model:show="display" @childIsPayEmptyInvoice="listenIsPayEmptyInvoice" />
                    </div>
                  </div>
                </div>

                <div v-if="borderStyle == 1 && (tiktokMemberId != null && tiktokMemberId != '')" class="flex flex-col">
                  <div class="text-gray-700 text-left">
                    {{showLang[selectLang]['views']['Home']['personal_information_text']}}
                    <span v-if="tiktokIsPayEmptyInvoice" class="ml-5 text-gray-500 text-sm">{{showLang[selectLang]['views']['Home']['payment_information_text']}}</span>
                  </div>
                  <div class="lg:flex md:block sm:block justify-evenly my-8">
                    <div class="relative shadow h-28 w-28 border-white rounded-full overflow-hidden">
                      <img class="object-cover w-full h-full"
                        :src="tiktokImg">
                    </div>
                    <div class="flex-auto sm:ml-5 justify-evenly">
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['member_name_text']}}</span>
                        <span class="text-gray-500">{{ tiktokMemberName }}</span>
                      </div>
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['member_email_text']}}</span>
                        <span class="text-gray-500">
                          <span v-if="!isEditEmail">{{ tiktokEmail }}</span>
                          <input
                            v-if="isEditEmail"
                            v-model="tiktokTmpEmail"
                            class="p-inputtext p-component py-0 w-60 h-4 underline-box border-show bg-transparent"
                            type="text"
                          />
                          <button
                            v-if="isEditEmail"
                            class="hover:bg-gray-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-gray-400 text-xs transition duration-500 ease-in-out border-2"
                            @click="isEditEmail=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                          <button
                            v-if="isEditEmail"
                            class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-blue-800 text-xs transition duration-500 ease-in-out border-2 border-yellow-400"
                            @click="emailUpdate()"
                            >{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                          <i
                            v-if="!isEditEmail"
                            class="pi pi-pencil cursor-pointer pl-2"
                            style="fontSize: 0.8rem"
                            @click="viewEdit('email')"
                            v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                        </span>
                      </div>
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['member_phone_text']}}</span>
                        <span class="text-gray-500">
                          <span v-if="!isEdit">{{ tiktokPhone }}</span>
                          <input
                            v-if="isEdit"
                            v-model="tiktokTmpPhone"
                            class="p-inputtext p-component py-0 w-28 h-4 underline-box border-show bg-transparent"
                            type="text"
                          />
                          <button
                            v-if="isEdit"
                            class="hover:bg-gray-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-gray-400 text-xs transition duration-500 ease-in-out border-2"
                            @click="isEdit=false">{{showLang[selectLang]['views']['Home']['member_phone_update_cancel_button_text']}}</button>
                          <button
                            v-if="isEdit"
                            class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-3 h-5 mx-auto text-blue-800 text-xs transition duration-500 ease-in-out border-2 border-yellow-400"
                            @click="phoneUpdate()"
                            >{{showLang[selectLang]['views']['Home']['member_phone_update_modify_button_text']}}</button>
                          <i
                            v-if="!isEdit"
                            class="pi pi-pencil cursor-pointer pl-2"
                            style="fontSize: 0.8rem"
                            @click="viewEdit('phone')"
                            v-tooltip="`${showLang[selectLang]['views']['Home']['member_phone_update_text']}`"></i>
                        </span>
                      </div>
                      <div class="lg:flex md:block sm:block pt-2 text-sm text-gray-400">
                        <span class="text-gray-800 md:px-4 sm:px-4">{{showLang[selectLang]['views']['Home']['payment_info_text']}}</span>
                        <a href="javascript:void(0);" class="text-blue-500 underline" @click="display=true">{{showLang[selectLang]['views']['Home']['payment_info_click_text']}}</a>
                      </div>
                      <PaymentInfoDialog v-bind:lang="showLang[selectLang]" v-bind:invoices="tiktokInvoices" v-bind:borderStyle="borderStyle" v-bind:memberId="tiktokMemberId" v-model:show="display" @childIsPayEmptyInvoice="listenIsPayEmptyInvoice" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <Mask :isDisplay="nowStep > -1" />
  <PlanMask
    v-if="nowStep == 1"
    :nowStep="nowStep"
    :selectLang="selectLang"
    @nextStep="nextStep"
    @closeTips="closeTips"
  />
  <LinkAccountMask
    v-if="nowStep >= 2 && nowStep <= 7 ||  nowStep == 31"
    :nowStep="nowStep"
    :selectLang="selectLang"
    :topCode="topCode"
    @nextStep="nextStep"
    @closeTips="closeTips"
    @closeForTeaching="doCloseForTeaching"
  />
</template>

<script>
  // @ is an alias to /src
  import { createApp } from 'vue'
  import Mask from '@/components/Event/Mask.vue';
  import PlanMask from '@/components/Mask/PlanMask.vue';
  import LinkAccountMask from '@/components/Mask/LinkAccountMask.vue';
  
  import Header from '@/components/Header.vue'
  import Plan from '@/components/Plan/Index.vue'
  import TikTokPlan from '@/components/TikTokPlan/Index.vue'
  import LinkAccount from '@/components/LinkAccount/Index.vue'
  import PaymentInfoDialog from '@/components/Dialog/PaymentInfoDialog.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/lang.json'
  import tiktokLang from '@/language/tiktok_lang.json'

  export default {
    name: 'Home',
    components: {
      Mask,
      PlanMask,
      LinkAccountMask,
      Header,
      Plan,
      TikTokPlan,
      LinkAccount,
      PaymentInfoDialog,
      Loading
    },
    props: {
      newTeaching: {
        type: Boolean,
        default: false
      },
      getFirstLoginStatus: {
        type: Array
      },
      getTransmitFbNum: {
        type: String,
        default: ''
      },
      getTransmitTiktokNum: {
        type: String,
        default: ''
      },
      useFbCustomize: {
        type: Boolean,
      },
      closeForTeaching: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        showTiktokLangg: tiktokLang,
        nowStep: -1,
        topCode: null,
        isEdit: false,
        isEditEmail: false,
        display: false,
        get_num: null,
        post_num: null,
        get_api_num: null,
        post_api_num: null,
        user_id: null,
        id: null,
        is_expired:null,
        account: null,
        member_name: null,
        email: null,
        tmp_email: null,
        phone: null,
        tmp_phone: null,
        img: null,
        showPlans: false,
        showMemberInfo: false,
        memberId: null,
        usePlanId: 1,
        connectionCard: false,
        isPay_emptyInvoice: false,
        adaccountData: 0,
        pageData: 0,
        firstLoginStatue: 'N',
        transmitFbNum: null,
        transmitTiktokNum: null,
        source: null,
        user_info:{
                user_id: null,
                tiktok_user_id: null,
        },
        plans:{
                expire_time:null,
                plan_title:null,
                plan_amount:null,
                plan_description:null,
                plan_free:null,
                plan_a:null,
                plan_b:null,
                plan_c:null,
                plan_o:null,
              },
        invoices:{
                  identifier:null,
                  name:null,
                  address:null,
                  mobile:null,
                  email:null,
                  card_no:null,
                },
        payList: null,
        userStatus: null,
        tipsStatus: 'progress',
        borderStyle: 0,
        tiktokUserStatus:null,
        tiktokIsExpired:null,
        tiktokAccount: null,
        tiktokMemberName: null,
        tiktokEmail: null,
        tiktokTmpEmail: null,
        tiktokPhone: null,
        tiktokTmpPhone: null,
        tiktokImg: null,
        tiktokSource: null,
        tiktokMemberId: null,
        tiktokUsePlanId: 1,
        tiktokConnectionCard: false,
        tiktokIsPayEmptyInvoice: false,
        tiktokInvoices:{
          identifier:null,
          name:null,
          address:null,
          mobile:null,
          email:null,
          card_no:null,
        },
        tiktokPlans:{
          expire_time:null,
          plan_title:null,
          plan_amount:null,
          plan_description:null,
          plan_free:null,
          plan_a:null,
          plan_b:null,
          plan_c:null,
        },
      }
    },
    created() {
      let hash = this.$route.params.id;
      console.log('home created');

      if(hash != '' && hash != null && typeof hash != 'undefined'){

        axios
          .post('https://test.autoturn.net/inside/api/get_lang.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.selectLang = response.data.return_data

              axios
                .post('https://test.autoturn.net/inside/api/login.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  type: this.$route.params.type
                }))
                .then((response) => {
                  console.log('login response');
                  console.log(response);
                  if(response.data.status == 'success'){
                    // console.log('created:'+response.data.status);
                    // self.first_name = response.data.firstName;
                    // this.first_name = response.data.firstName
                    this.userStatus = response.data.userStatus;
                    this.is_expired = response.data.is_expired;
                    this.account = response.data.account;
                    this.member_name = response.data.name;
                    this.email = response.data.email;
                    this.tmp_email = response.data.email;
                    this.phone = response.data.phone;
                    this.tmp_phone = response.data.phone;
                    this.img = response.data.img;

                    this.showMemberInfo = true;

                    this.source = response.data.source;
                    this.memberId = response.data.id;
                    this.usePlanId = response.data.payment_plan_id;
                    this.connectionCard = response.data.connection_card;
                    this.isPay_emptyInvoice = response.data.isPay_emptyInvoice;

                    this.user_info = {
                      user_id: response.data.user_id,
                      tiktok_user_id: response.data.tiktok_user_id,
                    }

                    this.invoices = {
                      identifier : response.data.invoice_identifier,
                      name : response.data.invoice_name,
                      address : response.data.invoice_address,
                      mobile : response.data.invoice_mobile,
                      email : response.data.invoice_email,
                      card_no : response.data.card_no,
                    }

                    let description = [];
                    if(response.data.plan_description != '' && response.data.plan_description != null && typeof response.data.plan_description != 'undefined'){
                      let tmpDescription = JSON.parse(response.data.plan_description);
                      for(let i = 0; i < tmpDescription.length; i++){
                        description.push(tmpDescription[i]);
                      }
                    }

                    this.plans = {
                      expire_time : response.data.expire_time,
                      label_unit: response.data.label_unit,
                      plan_title : response.data.plan_title,
                      is_amount : response.data.is_amount,
                      plan_amount : response.data.plan_amount,
                      plan_description : description,
                      plan_free : response.data.plan_free,
                      plan_a : response.data.plan_a,
                      plan_b : response.data.plan_b,
                      plan_c : response.data.plan_c,
                      plan_o : response.data.plan_o,
                    }

                    this.tiktokUserStatus = response.data.tiktok_userStatus;
                    this.tiktokIsExpired = response.data.tiktok_is_expired;
                    this.tiktokAccount = response.data.tiktok_account;
                    this.tiktokMemberName = response.data.tiktok_name;
                    this.tiktokEmail = response.data.tiktok_email;
                    this.tiktokTmpEmail = response.data.tiktok_email;
                    this.tiktokPhone = response.data.tiktok_phone;
                    this.tiktokTmpPhone = response.data.tiktok_phone;
                    this.tiktokImg = response.data.tiktok_img;

                    this.tiktokSource = response.data.tiktok_source;
                    this.tiktokMemberId = response.data.tiktok_id;
                    this.tiktokUsePlanId = response.data.tiktok_payment_plan_id;
                    this.tiktokConnectionCard = response.data.tiktok_connection_card;
                    this.tiktokIsPayEmptyInvoice = response.data.tiktok_isPay_emptyInvoice;

                    this.tiktokInvoices = {
                      identifier : response.data.tiktok_invoice_identifier,
                      name : response.data.tiktok_invoice_name,
                      address : response.data.tiktok_invoice_address,
                      mobile : response.data.tiktok_invoice_mobile,
                      email : response.data.tiktok_invoice_email,
                      card_no : response.data.tiktok_card_no,
                    }

                    let tiktokDescription = [];
                    if(response.data.tiktok_plan_description != '' && response.data.tiktok_plan_description != null && typeof response.data.tiktok_plan_description != 'undefined'){
                      let tiktokTmpDescription = JSON.parse(response.data.tiktok_plan_description);
                      for(let i = 0; i < tiktokTmpDescription.length; i++){
                        tiktokDescription.push(tiktokTmpDescription[i]);
                      }
                    }

                    this.tiktokPlans = {
                      expire_time : response.data.tiktok_expire_time,
                      label_unit: response.data.tiktok_label_unit,
                      plan_title : response.data.tiktok_plan_title,
                      is_amount : response.data.tiktok_is_amount,
                      plan_amount : response.data.tiktok_plan_amount,
                      plan_description : tiktokDescription,
                      plan_free : response.data.tiktok_plan_free,
                      plan_a : response.data.tiktok_plan_a,
                      plan_b : response.data.tiktok_plan_b,
                      plan_c : response.data.tiktok_plan_c,
                    }

                    // console.log(this.plans);

                    // let _type = 0;
                    // if((this.tiktokMemberId != '' && this.tiktokMemberId != null && typeof this.tiktokMemberId != 'undefined') && (this.memberId == '' || this.memberId == null || typeof this.memberId == 'undefined')){
                    //   _type = 1;
                    // }

                    // axios
                    //   .post('https://test.autoturn.net/inside/api/payment_table.php', Qs.stringify({
                    //     s_code: this.$route.params.id,
                    //     type: _type
                    //   }))
                    //   .then((payResponse) => {
                    //     if(payResponse.data.status == 'success'){
                    //       this.payList = payResponse.data.return_data
                    //     }

                        this.showPlans = true;
                    //   });
                  }

                  if(response.data.status == 'error'){
                    console.log('home logout');
                    // window.location.href = "https://ci.local/_autoturn_local_inside/index.php/login/view";
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Home']['axios']['login_error_title'],
                      text: this.showLang[this.selectLang]['views']['Home']['axios']['login_error_info_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Home']['axios']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout/"+hash+"?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout/"+hash+"?o=1";
                      }
                    })
                  }

                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: '帳號資訊',
                      text: '會員資料已過期，請重新登入。',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: '確定'
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                      }
                    })
                  }
                });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Home']['axios']['swal_title'],
                text: response.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Home']['axios']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }
          });

      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['Home']['axios']['login_empty_title'],
          text: this.showLang[this.selectLang]['views']['Home']['axios']['login_empty_info_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['Home']['axios']['confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }

    },
    watch:{
      'newTeaching': function(v){
        console.log('home newTeaching');
        console.log(v);

        console.log('b this.nowStep');
        console.log(this.nowStep);
        let tmpStatus = v.split('_');

        console.log(tmpStatus);
        console.log(typeof tmpStatus[0]);

        if(tmpStatus[0] == 'true'){
          this.nowStep = 3;
        }
        console.log('a this.nowStep');
        console.log(this.nowStep);
      },
      'getFirstLoginStatus': function(v){
        console.log('watch getFirstLoginStatus');
        console.log(v);
        if(v.data.return_data.first_login != '' && v.data.return_data.first_login != null && typeof v.data.return_data.first_login != undefined){
          this.firstLoginStatue = v.data.return_data.first_login;
        }
      },
      'getTransmitFbNum': function(v){
        console.log('watch getTransmitFbNum');
        console.log(v);
        console.log(this.transmitFbNum);
        this.transmitFbNum = v;
        console.log(this.transmitFbNum);
      },
      'getTransmitTiktokNum': function(v){
        console.log('watch getTransmitTiktokNum');
        console.log(v);
        console.log(this.transmitTiktokNum);
        this.transmitTiktokNum = v;
        console.log(this.transmitTiktokNum);
      },
      'closeForTeaching': function(v){
        console.log('home closeForTeaching');
        console.log(v);

        axios
          .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'N',
          }))
          .then((adResponse) => {
            this.nowStep = -1;
            this.firstLoginStatue = 'N';
          });
      },
    },
    methods: {
      viewEdit(type){
        if(type == 'email'){
          this.tmp_email = this.email
          this.isEditEmail = !this.isEditEmail
        }

        if(type == 'phone'){
          this.tmp_phone = this.phone
          this.isEdit = !this.isEdit
        }
      },
      phoneUpdate(){
        let phone = this.tmp_phone

        if(this.borderStyle == 1){
          phone = this.tiktokTmpPhone
        }

        axios
          .post('https://test.autoturn.net/inside/api/data/phone_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            form_data: phone,
            type: this.borderStyle
          }))
          .then((response) => {
            // console.log(response.data);
            this.$swal(response.data.info);
            if(response.data.status == 'success'){
              this.phone = phone
            }
            this.isEdit=false;
          });
      },
      emailUpdate(){
        let email = this.tmp_email

        if(this.borderStyle == 1){
          email = this.tiktokTmpEmail
        }

        axios
          .post('https://test.autoturn.net/inside/api/data/email_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            form_data: email,
            type: this.borderStyle
          }))
          .then((response) => {
            // console.log(response.data);
            this.$swal(response.data.info);
            if(response.data.status == 'success'){
              this.email = email
            }
            this.isEditEmail=false;
          });
      },
      useLang(v){
        console.log('home methods useLang');
        console.log(v);

        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

        console.log('this.selectLang');
        console.log(this.selectLang);
        console.log('showLang['+v+'][msg]');
        console.log(this.showLang[v]['msg']);

        document.title = this.showLang[this.selectLang]['views']['Home']['mounted']['page_name']+' - AutoTurn';
      },
      listenIsPayEmptyInvoice(v){
        this.isPay_emptyInvoice = v
      },
      nextStep(v) {
        console.log('v');
        console.log(v);

        axios
          .post('https://test.autoturn.net/inside/api/member_info.php', Qs.stringify({
            s_code: this.$route.params.id,
          }))
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
            console.log('home member_info.php');
            if(adResponse.data.status == 'success'){
              this.userName = adResponse.data.return_data.name
              this.userAccount = adResponse.data.return_data.account
              this.userImg =  adResponse.data.return_data.img

              console.log(adResponse.data.return_data.first_login);

              if(adResponse.data.return_data.first_login == 'Y'){
                if(v != '' && v != null && typeof v != 'undefined'){
                  let returnDataTypeof = typeof v;
                  let returnData = -1;

                  console.log('returnDataTypeof');
                  console.log(returnDataTypeof);

                  if(returnDataTypeof == 'string'){
                    returnData = v.indexOf('act=');
                  }

                  if(returnData != -1 && this.nowStep == -1){
                    //服務條款
                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    todayForm = yearForm + monthForm + dateForm + timeForm;

                    this.topCode = 'true_'+v+'_'+todayForm;

                    console.log('this.topCode');
                    console.log(this.topCode);

                    var iHeight = 600;
                    var iWidth = 1000;
                    //获得窗口的垂直位置
                    var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                    //获得窗口的水平位置
                    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                    var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,titlebar=no';

                    var ch_window = window.open('https://www.facebook.com/customaudiences/app/tos/?'+v, '', windowStyle);

                    var timer = setInterval(function() {
                      console.log('warning ch_window:', ch_window);
                      if(ch_window.closed) {
                        clearInterval(timer);
                        // window.location.reload();
                      }
                    }, 1000);
                  } else if(v == 6 || v == 4){
                    if(this.tipsStatus == 'progress'){
                      this.nowStep = 7;
                    }
                  } else {
                    this.nowStep = this.nowStep + 1;
                  }
                } else if(v == 6 || v == 4){
                  if(this.tipsStatus == 'progress'){
                    this.nowStep = 7;
                  }
                } else if(typeof v == 'undefined' && (this.adaccountData == 0 || this.pageData == 0)){
                  this.nowStep = 31;
                } else {
                  this.nowStep = this.nowStep + 1;
                }
                console.log('this.tipsStatus');
                console.log(this.tipsStatus);
                console.log('this.nextStep');
                console.log(this.nowStep);

                if(this.nowStep == 7 && this.tipsStatus == 'progress'){
                  this.$emit('nextStep', this.nowStep);
                }
              } else {
                console.log('tos');
                console.log(v);
                let returnData = -1;

                if(v != '' && v != null && typeof v != 'undefined'){
                   let returnDataTypeof = typeof v;

                   if(returnDataTypeof == 'string'){
                      returnData = v.indexOf('act=');
                    }
                }

                if(returnData != -1){
                  var iHeight = 600;
                  var iWidth = 1000;
                  //获得窗口的垂直位置
                  var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                  //获得窗口的水平位置
                  var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                  var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,titlebar=no';

                  var ch_window = window.open('https://www.facebook.com/customaudiences/app/tos/?'+v, '', windowStyle);

                  var timer = setInterval(function() {
                    console.log('warning ch_window:', ch_window);
                    if(ch_window.closed) {
                      clearInterval(timer);
                      // window.location.reload();
                    }
                  }, 1000);
                }
              }


            }
          });        
      },
      closeTips(v) {
        this.nowStep = -1;
        console.log('closeTips');
        console.log(v);
        console.log(this.nowStep);

        if(v == 'notSmooth'){
          axios
          .post('https://test.autoturn.net/inside/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'N',
          }))
          .then((adResponse) => {
            this.firstLoginStatue = 'N';
          });
        }

        if(v == 'stageClose'){
          this.tipsStatus = 'stop';
        }
      },
      openFirstLogin(v){
        console.log('home openFirstLogin');
        console.log(v);

        let tmpStatus = v.split('_');

        console.log(tmpStatus);
        console.log(typeof tmpStatus[0]);

        if(tmpStatus[0] == 'Y'){
          axios
          .post('https://test.autoturn.net/inside/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'Y',
          }))
          .then((adResponse) => {
            this.firstLoginStatue = 'Y';
          });
        }

        this.$emit('childHomeOpenFirstLogin', v);
      },
      setChangeLinkType(v){
        console.log('setChangeLinkType');
        console.log(v);
        this.$emit('childSetChangeLinkType', v);
      },
      updateAdaccount(v){
        this.adaccountData = v;
      },
      updatePage(v){
        this.pageData = v;
      },
      childActive(v){
        console.log('childActive');
        console.log(v);

        this.borderStyle = v

        axios
          .post('https://test.autoturn.net/inside/api/payment_table.php', Qs.stringify({
            s_code: this.$route.params.id,
            type: v
          }))
          .then((payResponse) => {
            if(payResponse.data.status == 'success'){
              this.payList = payResponse.data.return_data
            }

            this.showPlans = true;
          });

        this.$emit('childBorderStyle', v);
      },
      canUseFbCustomize(v){
        console.log('canUseFbCustomize', v);
        this.$emit('canUseFbCustomize', v);
      },
      doCloseForTeaching(){
        console.log('home doCloseForTeaching');

        axios
          .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            status: 'N',
          }))
          .then((adResponse) => {
            this.nowStep = -1;
            this.firstLoginStatue = 'N';
          });
      }
    },
    mounted () {
      console.log('mounted this.showLang');
      console.log(this.showLang);
      console.log(this.selectLang);

      // document.title = this.showLang[this.selectLang]['views']['Home']['mounted']['page_name']+' - AutoTurn';
      // this.users = {
      //               first_name:'seedaaaa',
      //               second_name:'jasonsssss'
      //             };

      // this.invoices = {
      //                         identifier : 100,
      //                         name : 200,
      //                         address : 300,
      //                         mobile : 40,
      //                         email : 500,
      //                         card_no : 600,
      //                       }

      // axios
      //   .post('https://test.autoturn.net/inside/api/login.php', Qs.stringify({
      //     s_code: this.$route.params.id
      //   }))
      //   .then((response) => {
      //     if(response.data.status == 'success'){
      //       console.log('mounted:'+response.data.status);
      //       // self.first_name = response.data.firstName;
      //       // this.first_name = response.data.firstName
      //       this.account = response.data.account;
      //       this.member_name = response.data.name;
      //       this.phone = response.data.phone;

      //       // this.invoices = {
      //       //                   identifier : response.data.invoice_identifier,
      //       //                   name : response.data.invoice_name,
      //       //                   address : response.data.invoice_address,
      //       //                   mobile : response.data.invoice_mobile,
      //       //                   email : response.data.invoice_email,
      //       //                   card_no : response.data.card_no,
      //       //                 }
      //     } else {
      //       window.location.href = "https://test.autoturn.net/inside/index.php/login/view";
      //     }
      //   });

      ////////////////////////////////////////////

      // axios
      //   .get('https://test.autoturn.net/inside/index.php/index/user_id')
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.user_id);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.user_id = response.data.user_id;
      //   });

      // axios
      //   .get('https://test.autoturn.net/inside/index.php/index/test_get/722')
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.get_num = response.data.age;
      //   });

      // axios
      //   .post('https://test.autoturn.net/inside/index.php/index/test_post', Qs.stringify({
      //     num: 723
      //   }))
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.post_num = response.data.age;
      //   });

      // axios
      //   .get('https://test.autoturn.net/inside/api/get_data.php?frist_name=lee&last_name=seed&age=1487')
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.get_api_num = response.data.age;
      //   });

      // axios
      //   .post('https://test.autoturn.net/inside/api/post_data.php', Qs.stringify({
      //     frist_name: 'lee',
      //     last_name: 'seed',
      //     age: 9487
      //   }))
      //   .then((response) => {
      //     console.log(response.data);
      //     console.log(response.data.age);
      //     // self.first_name = response.data.firstName;
      //     // this.first_name = response.data.firstName
      //     this.post_api_num = response.data.age;
      //   });
    },
    computed: {
      getFirstLoginStatusData: {
        get: function () {
          return this.getFirstLoginStatus
        },
        set: function (value) {
          this.$emit('update:getFirstLoginStatusData', value)
        },
      },
    }
  }
</script>

<style scope>
  .plan-free {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(50deg, rgba(127, 220, 250, 1) 0%, rgba(47, 202, 189, 1) 100%);
  }
  .plan-a {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(98,152,215,1) 0%, rgba(128,213,250,1) 100%);
  }
  .plan-b {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(29,97,159,1) 0%, rgba(114,182,244,1) 100%);
  }
  .plan-c {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(247,214,118,1) 0%, rgba(255,222,126,1) 100%);
  }
  .plan-o {
    width: 215px;
    height: 90px;
    background: rgb(127, 220, 250);
    background: linear-gradient(90deg, rgba(232,193,119,1) 0%, rgba(250,219,118,1) 100%);
  }

  .tiktok-plan-free {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(50deg, rgba(33, 3, 24, 1) 0%, rgba(143, 143, 143, 1) 100%);
  }
  .tiktok-plan-a {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(90deg, rgba(33, 3, 24,1) 0%, rgba(143, 143, 143,1) 100%);
  }
  .tiktok-plan-b {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(90deg, rgba(33, 3, 24,1) 0%, rgba(143, 143, 143,1) 100%);
  }
  .tiktok-plan-c {
    width: 215px;
    height: 90px;
    background: rgb(224, 224, 224);
    background: linear-gradient(90deg, rgba(246, 14, 95,1) 0%, rgba(255, 129, 66,1) 100%);
  }

  @media (min-width: 768px) and (max-width: 1440px) {
    .plan-free, .plan-a, .plan-b, .plan-c, .tiktok-plan-free, .tiktok-plan-a, .tiktok-plan-b, .tiktok-plan-c {
      width: auto;
      height: 90px;
    }
  }

  @media (max-width: 767px) {
    .plan-free, .plan-a, .plan-b, .plan-c, .tiktok-plan-free, .tiktok-plan-a, .tiktok-plan-b, .tiktok-plan-c {
      width: auto;
      height: 50px;
    }
  }
</style>